import { Button, Form, GetProp, Input, TableColumnsType, TableProps } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import "./Order.css"
import pako from 'pako';
import { Inventary } from '../../Models/Inventary';
import { getAllCardsInventary } from '../../Api/Cards';
import { PromiseSesionContext } from '../../Machines/SesionMachine';
import { TransferItem, TransferProps } from 'antd/es/transfer';
import TableTransfer from './TableTransfer';
import columns from './TableOrder';

const Order = () => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [lentInitialOrder, setLenInitialOrder] = React.useState<number>(0);
    const [totalOrder, setTotalOrder] = React.useState<number>(0);
    const [totalOrderBCV, setTotalOrderBCV] = React.useState<number>(0);


    const [inventary, setInventary] = React.useState<Inventary[]>([]);
    const [order, setOrder] = React.useState<Inventary[]>([]);

    const {sendError} = useContext(PromiseSesionContext);
    const [targetKeys, setTargetKeys] = useState<TransferProps['targetKeys']>([]);
    
    interface TableTransferProps extends TransferProps<Inventary> {
    dataSource: Inventary[];
    leftColumns: TableColumnsType<Inventary>;
    rightColumns: TableColumnsType<Inventary>;
    }

    const onChange: TableTransferProps['onChange'] = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys);
  };

    const onFinish = (values: FieldType)=>{
        try{
            setLoading(true)
           let finalOrder= decodeAndDecompress(values.description)

          setLenInitialOrder(finalOrder.length)

           // Extrae solo los IDs del array de objetos
            const idsToKeep: number[] = finalOrder.map(filterObj => filterObj.id);
            // Convierte el array de IDs a un Set para búsquedas rápidas (O(1))
            const idsSet = new Set(idsToKeep);

           let completeOrder=inventary.filter((x:Inventary)=>{return idsSet.has(x.id)})
            const orderWithKeys:Inventary[] = completeOrder.map(item => ({
                ...item,
                quantity:finalOrder.filter(x=> x.id===item.id)[0].cant || 0,
                // Como item.id es string, lo usamos directamente como clave
                key: item.id,
            }));
            setOrder(orderWithKeys)
            setLoading(false)

        }
        catch{
            setLoading(false)

            sendError({type: "ERROR", data:{message:"Error al cargar la orden", type:"error"}})

        }
    }

    type FieldType = {
        description: string;
      };
    interface CompactItem {
    id: number;
    cant: number;
    }


    
  useEffect(() => {

      getAllInventary();



  }, []);

    useEffect(() => {

      const idsSet = new Set(targetKeys);
      let completeOrder=order.filter((x:Inventary)=>{return idsSet.has(x.id)})
      let newTotal= 0
      let newTotalBCV =0
      completeOrder.forEach((x:Inventary)=>{
        newTotal= newTotal + (x.quantity)* x.product.cash_price
        newTotalBCV = newTotalBCV + (x.quantity)* x.product.price

      })

      setTotalOrder(newTotal)
      setTotalOrderBCV(newTotalBCV)
  }, [targetKeys]);

  const getAllInventary = async () => {
    try{
      setLoading(true);

      const response = await getAllCardsInventary();
      // console.log(response);

      setInventary(response.products);
      //calculateAllInventaryTotalPrice(response.products);
      setLoading(false);
    }
    catch(error){
      setLoading(false);
      sendError({type: "ERROR", data:{message:"Error al cargar el inventario, puede que el catálogo esté deshabilitado y estará disponible con nuevas cartas pronto.", type:"error"}})

    }
  }

  // --- Proceso de Descompresión ---
  const decodeAndDecompress = (order:string) => {

    try {
      // 1. Decodificar la cadena Base64 a una cadena binaria
      const decoded = atob(order);
      
      // 2. Convertir la cadena binaria a un Uint8Array
      const uint8Array = Uint8Array.from(decoded.split('').map(char => char.charCodeAt(0)));
      
      // 3. Descomprimir los bytes a una cadena de texto
      const decompressed = pako.inflate(uint8Array, { to: 'string' });
      
      // 4. Convertir la cadena de texto de vuelta al array compacto
      const parsedData: CompactItem[] = JSON.parse(decompressed);

    //   setDecompressedData(parsedData);
        return parsedData
    } catch (error) {
        return []
      console.error("Error al descomprimir los datos:", error);
    }
  };

  const filterOption = (input: string, item: Inventary) =>
  item.product.name?.includes(input) 

  return (
    <>
        <div className='order-description'>
           <Form
                disabled={loading}
                name="basic"
                className='FormOrderComponent'
                layout={"vertical"}
                initialValues={{ remember: true, card_type:"normal", language:"EN", condition:"NM", cantidad:1, precio:0.1 }}
                onFinish={onFinish}
                style={{width:"100%"}}
                autoComplete="off">
                
                <Form.Item<FieldType>
                name="description"
                style={{width:"90%"}}
                rules={[{ required: true, message: "El campo es requerido" }]}
                >
                <Input style={{}} type='description'  />

                </Form.Item>

                <Form.Item >


                <Button style={{width:"100%"}}  type="primary" htmlType="submit">
                    Preparar
                </Button>

 
                </Form.Item>
            </Form> 

            <div>
              <span>Cartas: {lentInitialOrder} / {order.length} - Total:{totalOrderBCV} BCV / {totalOrder} CASH</span>
                <TableTransfer
                dataSource={order}
                targetKeys={targetKeys}
                disabled={false}
                showSearch
                showSelectAll={false}
                onChange={onChange}
                filterOption={filterOption}
                leftColumns={columns}
                rightColumns={columns}
            />
            </div>

            <div>
                <Button style={{}}  type="primary" >
                    Completar compra
                </Button>
            </div>

        </div>
    
    </>
  )
}

export default Order